export default "__VITE_ASSET__DtYhA0kb__"